import ThumbDown from '@mui/icons-material/ThumbDownOutlined';
import ThumbUp from '@mui/icons-material/ThumbUpOutlined';
import { Box, styled } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { Feedback, FeedbackType } from '../../types';
import RateButton from './RateButton';
import RecommendationResultsSection from './RecommendationResultsSection';
import useRateRecommendation from './useRateRecommendation';

interface Props {
  feedback: Feedback;
}

const RateButtonsWrapper = styled(RecommendationResultsSection)``;

const RateButtons: FC<Props> = ({ feedback }) => {
  const { t } = useTranslation();
  const { rateRecommendation, currentRate } = useRateRecommendation(feedback);
  return (
    <RateButtonsWrapper
      sx={{
        marginTop: 4,
      }}
      title={t('aiRecommendations:results:rate')}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: {
            xs: 'column',
            sm: 'row',
          },
          gap: '1rem',
        }}
      >
        <RateButton
          icon={ThumbUp}
          onClick={() => rateRecommendation(FeedbackType.positive)}
          isActive={currentRate === FeedbackType.positive}
        >
          {t('aiRecommendations:results:goodRecommendation')}
        </RateButton>
        <RateButton
          icon={ThumbDown}
          onClick={() => rateRecommendation(FeedbackType.negative)}
          isActive={currentRate === FeedbackType.negative}
        >
          {t('aiRecommendations:results:badRecommendation')}
        </RateButton>
      </Box>
    </RateButtonsWrapper>
  );
};

export default RateButtons;
